import { useState, useEffect } from "react";
import React from "react";
import ReactSelect from "react-select";
import axios from "axios";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import InputAdornment from "@mui/material/InputAdornment";
import Modal from "@mui/material/Modal";
import CircularProgress from "@mui/material/CircularProgress";
import Swal from "sweetalert2";
import {
  Box,
  Button,
  Container,
  Stack,
  SvgIcon,
  Typography,
  Grid,
  Checkbox,
  TextField,
  Alert,
  Paper,
  InputLabel,
  FormControlLabel,
} from "@mui/material";
import Moment from "moment";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import { useAlert } from "react-alert";
import fileDownload from "js-file-download";
import { useLocation, Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Download from "@mui/icons-material/Download";
import Headroom from "react-headroom";
import { useSelector } from "react-redux";
import PreviewClaim from "./PreviewClaim";
const ClaimRegistration = (props) => {
  document.title = "Claim Registration | LuxBilling";
  const rights = useSelector((state) => state.login.rights);
  const token = localStorage.getItem("Token");
  const auth = `Bearer ${token}`;
  const headers = {
    Authorization: auth,
  };
  const [charges, setcharges] = useState();
  const [charges1, setcharges1] = useState();
  const [charges2, setcharges2] = useState();
  const [charges3, setcharges3] = useState();
  const [code, setcode] = useState("");
  const [code1, setcode1] = useState("");
  const [code2, setcode2] = useState("");
  const [code3, setcode3] = useState("");
  const [UNIT, setUNIT] = useState("");
  const [UNIT1, setUNIT1] = useState("");
  const [UNIT2, setUNIT2] = useState("");
  const [UNIT3, setUNIT3] = useState("");
  const [ProcedureID, setProcedureID] = useState(0);
  const [ProcedureID1, setProcedureID1] = useState(0);
  const [ProcedureID2, setProcedureID2] = useState(0);
  const [ProcedureID3, setProcedureID3] = useState(0);
  const [d, setd] = useState([]);
  const [d1, setd1] = useState([]);
  const [d2, setd2] = useState([]);
  const [d3, setd3] = useState([]);
  const [dos, setdos] = React.useState("");
  const [Dos, setDOS] = React.useState("");
  const [dos1, setdos1] = React.useState("");

  const [dos2, setdos2] = React.useState("");
  const [dos3, setdos3] = React.useState("");

  const patientName = props.callingFrom == "Patient" ? props.patientName : "";
  const claimpatientid =
    props.callingFrom == "Patient" ? props.claimpatientId : "";
  const patientid =
    props.callingFrom == "Patient" && props.claimpatientId > 0
      ? props.claimpatientId
      : props.patientId;

  const fields = [
    "id",
    "patientId",
    "insuranceName",
    "patientName",
    "billingProvider",
    "attendingPhysician",
    "referringPhysicianName",
    "dos",
    "dos1",
    "dos2",
    "pos",
    "referringPhysicianId",
    "memberId",
    "cpt1",
    "cpt2",
    "practiceId",
    "cpt3",
    "charges1",
    "charges2",
    "charges3",
    "acceptAssignment",
    "dontAcceptAssignment",
    // "defaultTwoweek",
    // "FollowUp5Days",
    // "FollowUp10Days",
    "followUpTime",
    "secondaryPending",
    "submitted",
    "payment",
    "referringPhysician",
    "authNumber",
    "frontnote",
    "backnote",
    "renderingProvider",
    "amountDue",
    "discount",
    "additionalInformation",
    "writeOff",
    "claimTotal",
    "amountPaid",
    "compeleted",
    "payment",
    "amountAllowed",
    "totalCharges",
    "adjustments",
    "Carries",
    "referringProvider",
    "createdDate",
    "updatedDate",
    "statusType",
  ];
  const defValues = {
    id: 0,
    patientId: 0,
    billingProvider: 0,
    attendingPhysician: 0,
    insuranceName: "",
    memberId: 0,
    referringPhysician: 0,
    practiceId: "",
    patientName: "",
    patientName: patientName,
    dos: "",
    dos1: "",
    dos2: "",
    pos: "",
    frontnote: "",
    amountDue: 0,
    discount: 0,
    writeOff: 0,
    claimTotal: 0,
    amountPaid: 0,
    amountAllowed: 0,
    totalCharges: 0,
    adjustments: 0,
    backnote: "",
    referringPhysicianName: "",
    referringPhysicianId: 0,
    renderingProvider: "",
    cpt1: "",
    cpt2: "",
    cpt3: "",
    charges1: "",
    charges2: "",
    charges3: "",
    authNumber: "",
    acceptAssignment: "",
    dontAcceptAssignment: "",
    // defaultTwoweek: "",
    // FollowUp5Days: "",
    // FollowUp10Days: "",
    followUpTime: "14",
    secondaryPending: "",
    additionalInformation: "",
    submitted: false,
    payment: false,
    Carries: "",
    referringProvider: "",
    createdDate: "",
    updatedDate: "",
    compeleted: false,
    statusType: "Pending",
    diagnosis: {
      id: 0,
      claimId: 0,
      diagSequence: 0,
      description: "",
      code: "",
      dx1: "",
      dx2: "",
      dx3: "",
      dx4: "",
      dx5: "",
      dx6: "",
      dx7: "",
      dx8: "",
      dx9: "",
      dx10: "",
      dx11: "",
      dx12: "",
      patientId: 0,
    },
    //     procedures: [{
    //         id: 0,
    //         claimId: 0,
    //         code:'',
    //         mod1: '',
    //         mod2:'',
    //         mod3:'',
    //         mod4:'',
    //         dxPointer1:'',
    //         dxPointer2:'',
    //         dxPointer3:'',
    //         dxPointer4:'',
    //         pos:'',
    //         dosTo:'',
    //         charges:0,
    //         procedureSequence:0,

    //         units:0,
    //         dateOfServiceFrom,
    //         dateOfServiceTo,

    //     },

    // ],
  };
  const navigate = useNavigate();
  const alert = useAlert();

  const [claimId, setclaimId] = useState(props.claimId);
  const [patientNamee, setPatientNamee] = useState("");
  const [selectpatientid, setselectpatientid] = useState("");
  const [patient, setPatient] = React.useState(false);
  const [submittedprop, setsubmittedprop] = React.useState(false);
  const [patientData, setPatientData] = React.useState([]);
  const [searchText, setSearchText] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const diagArr = [
    "Diag1",
    "Diag2",
    "Diag3",
    "Diag4",
    "Diag5",
    "Diag6",
    "Diag7",
    "Diag8",
    "Diag9",
    "Diag10",
    "Diag11",
    "Diag12",
  ];
  const [diagId1, setdiagId1] = useState("");
  const [diagId2, setdiagId2] = useState("");
  const [diagId3, setdiagId3] = useState("");
  const [diagId4, setdiagId4] = useState("");
  const [diagId5, setdiagId5] = useState("");
  const [diagId6, setdiagId6] = useState("");
  const [diagId7, setdiagId7] = useState("");
  const [diagId8, setdiagId8] = useState("");
  const [diagId9, setdiagId9] = useState("");
  const [diagId10, setdiagId10] = useState("");
  const [diagId11, setdiagId11] = useState("");
  const [refresh, setRefresh] = useState(false);
  const validationSchema = Yup.object({
    dos: Yup.string().required("DOS is required"),
    patientName: Yup.string().required("Patient is required"),
  });
  const {
    register,
    control,
    handleSubmit,
    setValue,
    watch,
    getValues,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    reValidateMode: "onChange",
    context: undefined,
    criteriaMode: "firstError",
    shouldFocusError: true,
    shouldUnregister: false,
    shouldUseNativeValidation: false,
    delayError: undefined,
    resolver: yupResolver(validationSchema),
    defaultValues: defValues,
  });
  const [value1, setValue1] = React.useState(0);

  const patientListStyle = {
    cursor: "pointer",
    hover: {
      background: "#3b3b3b !important",
      color: "rgba(5, 152, 236, 0.637) !important",
    },
    color: "green",
    selection: {
      background: "#D7624E",
      color: "white",
    },
  };
  const [patientinsurancename, setpatientinsurancename] = useState("");
  const [patientiaddress, setpatientiaddress] = useState("");
  const [patientDOB, setpatientDOB] = React.useState(
    Moment().format("YYYY-MM-DD")
  );
  const [patientDetails, setPatientDetails] = useState({
    address: "",
    city: "",
    state: "",
    zipcode: "",
  });
  const Namee = props.Namee;
  useEffect(() => {
    if (patientid > 0) {
      setValue("patientName", Namee);
    }
  }, [patientid, Namee]);
  const [memberid, setmemeberid] = useState("");
  const [SecondarMemberid, setSecondarMemberid] = useState("");
  const [SecondarIsurancename, setSecondarIsurancename] = useState("");
  const [Nameo, setnameo] = useState("");
  useEffect(() => {
    if (selectpatientid > 0) {
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/Patients/SearchInsuranceName?patientId=${selectpatientid}`,
          {
            headers,
          }
        )
        .then((response) => {
          const Data = response[0];
          const fullAddress = [
            Data.address,
            Data.city,
            Data.state,
            Data.zipCode,
          ]
            .filter(Boolean)
            .join(", ");
          const primary = response.find(
            (r) => r.type?.toLowerCase() === "primary"
          );
          const secondary = response.find(
            (r) => r.type?.toLowerCase() === "secondary"
          );
          setpatientinsurancename(primary.planName);
          setpatientiaddress(fullAddress);
          setpatientDOB(Moment(Data.dob).format("YYYY-MM-DD"));
          setmemeberid(primary.memberId);
          setnameo(Data.patientName);
          setPatientDetails({
            address: response.address,
            city: response.city,
            state: response.state,
            zipcode: response.zipCode,
          });

          const SecondaryData = response[1];
          setSecondarIsurancename(secondary.planName);
          setSecondarMemberid(secondary.memberId);
        })

        .catch((error) => {
          console.error("There was an error!", error);
        });
    }
  }, [selectpatientid]);
  const callingFrom = props.callingFrom;

  useEffect(() => {
    if (patientid > 0) {
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/Patients/SearchInsuranceName?patientId=${patientid}`,
          {
            headers,
          }
        )
        .then((response) => {
          const Data = response[0];
          const fullAddress = [
            Data.address,
            Data.city,
            Data.state,
            Data.zipCode,
          ]
            .filter(Boolean)
            .join(", ");
          const primary = response.find(
            (r) => r.type?.toLowerCase() === "primary"
          );
          const secondary = response.find(
            (r) => r.type?.toLowerCase() === "secondary"
          );
          setpatientinsurancename(primary.planName);
          setpatientiaddress(fullAddress);
          setpatientDOB(Moment(Data.dob).format("YYYY-MM-DD"));
          setmemeberid(primary.memberId);
          setnameo(Data.patientName);

          const SecondaryData = response[1];
          setSecondarIsurancename(secondary.planName);
          setSecondarMemberid(secondary.memberId);
        })

        .catch((error) => {
          console.error("There was an error!", error);
        });
    }
  }, [patientid]);
  useEffect(() => {
    if (claimpatientid > 0) {
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/Patients/SearchInsuranceName?patientId=${claimpatientid}`,
          {
            headers,
          }
        )
        .then((response) => {
          const Data = response[0];
          const fullAddress = [
            Data.address,
            Data.city,
            Data.state,
            Data.zipCode,
          ]
            .filter(Boolean)
            .join(", ");
          const primary = response.find(
            (r) => r.type?.toLowerCase() === "primary"
          );
          const secondary = response.find(
            (r) => r.type?.toLowerCase() === "secondary"
          );
          setpatientinsurancename(primary.planName);
          setpatientiaddress(fullAddress);
          setpatientDOB(Moment(Data.dob).format("YYYY-MM-DD"));
          setmemeberid(primary.memberId);
          setnameo(Data.patientName);
          setPatientDetails({
            address: response.address,
            city: response.city,
            state: response.state,
            zipcode: response.zipCode,
          });

          const SecondaryData = response[1];
          setSecondarIsurancename(secondary.planName);
          setSecondarMemberid(secondary.memberId);
        })

        .catch((error) => {
          console.error("There was an error!", error);
        });
    }
  }, [claimpatientid]);
  ///Calling ClaimsByID
  const [AuthNumber, setAuthNumber] = useState("");

  useEffect(() => {
    if (claimId > 0) {
      var postdate = [claimId];
      let isComponentMounted = true;
      const fetchData = async () =>
        axios
          .get(
            `${process.env.REACT_APP_API_URL}/claims/ClaimsById?claimId=${claimId}`,
            {
              headers,
            }
          )
          .then((response) => {
            if (response) {
              fields.forEach((field) => setValue(field, response[field]));
              setProvider(response.providerName);
              setselectpatientid(response.patientId);
              setsubmittedprop(response.submitted);
              setAuthNumber(response.authNumber);
              var dateto342 = Moment(response.dos).format("YYYY-MM-DD");
              setDOS(dateto342);
              var dateto3421 = Moment(response.dos).format("YYYY-MM-DD");
              setdos(dateto3421);
              const procedures = response.procedures || [];
              if (procedures[0]) {
                setcharges(procedures[0].charges);
                setcode(procedures[0].code);
                setd(
                  procedures[0].dxPointer1
                    ? procedures[0].dxPointer1
                        .split(",")
                        .map((code) => String(code).trim())
                    : []
                );
                const rawDates = procedures[0]?.dosTo;
                const dateto1 = Moment(
                  rawDates,
                  Moment.ISO_8601,
                  true
                ).isValid()
                  ? Moment(rawDates).format("YYYY-MM-DD")
                  : "";
                setdos(dateto1);
                setProcedureID(procedures[0].id);
              }
              if (procedures[1]) {
                setcharges1(procedures[1].charges);
                setcode1(procedures[1].code);
                setd1(
                  procedures[1].dxPointer1
                    ? procedures[1].dxPointer1
                        .split(",")
                        .map((code) => String(code).trim())
                    : []
                );
                const rawDate = procedures[1]?.dosTo;
                const dateto12 = Moment(
                  rawDate,
                  Moment.ISO_8601,
                  true
                ).isValid()
                  ? Moment(rawDate).format("YYYY-MM-DD")
                  : "";
                setdos1(dateto12);
                setProcedureID1(procedures[1].id);
              }
              if (procedures[2]) {
                setcharges2(procedures[2].charges);
                setcode2(procedures[2].code);
                setd2(
                  procedures[2].dxPointer1
                    ? procedures[2].dxPointer1
                        .split(",")
                        .map((code) => String(code).trim())
                    : []
                );
                const rawDate1 = procedures[2]?.dosTo;
                const dateto12 = Moment(
                  rawDate1,
                  Moment.ISO_8601,
                  true
                ).isValid()
                  ? Moment(rawDate1).format("YYYY-MM-DD")
                  : "";
                setdos2(dateto12);
                setProcedureID2(procedures[2].id);
              }
              if (procedures[3]) {
                setcharges3(procedures[3].charges);
                setcode3(procedures[3].code);
                setd3(
                  procedures[3].dxPointer1
                    ? procedures[3].dxPointer1
                        .split(",")
                        .map((code) => String(code).trim())
                    : []
                );
                const rawDate123 = procedures[3]?.dosTo;
                const dateto123 = Moment(
                  rawDate123,
                  Moment.ISO_8601,
                  true
                ).isValid()
                  ? Moment(rawDate123).format("YYYY-MM-DD")
                  : "";
                setdos3(dateto123);
                setProcedureID3(procedures[3].id);
              }
              var diagnosis = response.diagnosis;
              setselectpatientid(response.patientId);
              setdiagId1(diagnosis.dx2 != undefined ? diagnosis.dx2 : "");
              setdiagId2(diagnosis.dx3 != undefined ? diagnosis.dx3 : "");
              setdiagId3(diagnosis.dx4 != undefined ? diagnosis.dx4 : "");
              setdiagId4(diagnosis.dx5 != undefined ? diagnosis.dx5 : "");
              setdiagId5(diagnosis.dx6 != undefined ? diagnosis.dx6 : "");
              setdiagId6(diagnosis.dx7 != undefined ? diagnosis.dx7 : "");
              setdiagId7(diagnosis.dx8 != undefined ? diagnosis.dx8 : "");
              setdiagId8(diagnosis.dx9 != undefined ? diagnosis.dx9 : "");
              setdiagId9(diagnosis.dx10 != undefined ? diagnosis.dx10 : "");
              setdiagId10(diagnosis.dx11 != undefined ? diagnosis.dx11 : "");
              setdiagId11(diagnosis.dx12 != undefined ? diagnosis.dx12 : "");
            }
          })
          .catch((error) => {
            console.error("There was an error!", error);
          });
      fetchData();
      return () => {
        isComponentMounted = false;
      };
    }
  }, [claimId]);
  function handleCancel() {
    navigate("/Claim");
  }
  const onclickcopy = () => {
    setValue("_id", "");
  };
  const [isLoading, setIsLoading] = useState(false);

  const onChangeHandle = async (value) => {
    setIsLoading(true);

    const sendData = {
      id: 0,
      lastName: value,
      firstName: "",
      ssn: "",
      status: "",
      cellPhone: "",
      address: "",
      dob: "",
    };
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/Patients/searchPatient`,
        sendData,
        { headers }
      )

      .then((response) => {
        setPatientData(response);
        setPatient(true);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsLoading(false);
      });
  };
  const [diagnosisList, setDiagnosisList] = useState([]);
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/Diagnosis/Diagnosis`, {
        headers,
      })
      .then((response) => {
        var prac = [];
        response.forEach((field) => {
          prac.push({
            label: field.code,
            value: field.id,
          });
        });
        setDiagnosisList(prac);
      })
      .catch((error) => {});
  }, []);

  const practiceID = localStorage.getItem("default_paractice");
  const User_Type = localStorage.getItem("User_Type");
  const [billingProvider, setbillingProvider] = useState([]);
  const [billingProviderID, setbillingProviderID] = useState("");
  const [RENDERINGProvider, setRENDERINGProvider] = useState([]);
  const [RENDERINGProviderID, setRENDERINGProviderID] = useState("");
  const [referringPhysicianName, setreferringPhysicianName] = useState([]);
  const [referringPhysicianNameID, setreferringPhysicianNameID] = useState();
  const [procedureCode1ID, setProcedureCode1ID] = useState("");
  const [procedureCode1List, setProcedureCode1List] = useState([]);
  const claimPracticeID = props.claimPracticeID;
  const PatientidOfClaim = props.claimpatientId || props.patientId;
  useEffect(() => {
    if (!claimPracticeID || claimPracticeID == practiceID) {
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/ReferringPhysicians/ReferringPhysicians?parcticeid=${practiceID}`,
          { headers }
        )
        .then((response) => {
          var rprov = [];

          response.forEach((field) => {
            rprov.push({
              label: `${field.lastName},${field.firstName}`,
              value: field.id,
              npi: field.npi,
            });
          });
          setreferringPhysicianName(rprov);
        })
        .catch((error) => {});
    } else {
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/ReferringPhysicians/ReferringPhysicians?patientid=${PatientidOfClaim}`,
          { headers }
        )
        .then((response) => {
          var rprov = [];

          response.forEach((field) => {
            rprov.push({
              label: `${field.lastName},${field.firstName}`,
              value: field.id,
              npi: field.npi,
            });
          });
          setreferringPhysicianName(rprov);
        })
        .catch((error) => {});
    }
  }, [practiceID, PatientidOfClaim, claimPracticeID]);
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/Procedures/Procedures`, {
        headers,
      })
      .then((response) => {
        var prac = [];
        response.forEach((field) => {
          prac.push({
            label: field.code,
            value: field.code,
            qasim: field.default_charges,
            unit: field.unit,
          });
        });
        setProcedureCode1List(prac);
      })
      .catch((error) => {});
  }, []);
  const [urldownload, seturldownload] = useState("");
  const [procedureError, setProcedureError] = useState("");
  const [diagnosisError, setDiagnosisError] = useState("");
  const [insuranceError, setInsuranceError] = useState("");
  const onSubmit = (data) => {
    const hasPrimary = patientinsurancename.trim() !== "";
    const hasSecondary = SecondarIsurancename.trim() !== "";

    if (!hasPrimary && !hasSecondary) {
      setInsuranceError("Please Go To Patient and Add Insurance First");
      return; // submit stop
    }
    setInsuranceError("");
    let isValid = true;
    if (!code) {
      setProcedureError("Procedure code is required.");
      isValid = false;
    } else {
      setProcedureError("");
    }

    if (d.length === 0) {
      setDiagnosisError("At least one diagnosis code is required.");
      isValid = false;
    } else {
      setDiagnosisError("");
    }

    if (!data.acceptAssignment && !data.dontAcceptAssignment) {
      setAssignmentError("Please select one option.");
     isValid = false;
    } else {
      setAssignmentError("");
    }
    if (!isValid) return;

    const postData = {
      ...data,
      acceptAssignment: data.acceptAssignment === true ? true : "",
      dontAcceptAssignment: data.dontAcceptAssignment === true ? true : "",
      // secondaryPending: data.statusType || "",
      // secondaryPending: data.secondaryPending === true ? true : "",
    };
    postData.payment = false;
    setSubmitting(true);
    postData.authNumber = AuthNumber;
    postData.practiceId = data.practiceId;
    postData.patientName = Namee;
    postData.compeleted = true;
    postData.patientId = patientid > 0 ? patientid : selectpatientid;
    console.log("testpatientid", postData.patientId);
    postData.totalCharges =
      (parseFloat(charges) || 0) +
      (parseFloat(charges1) || 0) +
      (parseFloat(charges2) || 0) +
      (parseFloat(charges3) || 0);
    if (claimId > 0) {
      postData.amountDue = data.totalCharges;
    }
    const DiagnosisCode = [
      Array.isArray(d) ? d.join(",") : "",
      Array.isArray(d1) ? d1.join(",") : "",
      Array.isArray(d2) ? d2.join(",") : "",
      Array.isArray(d3) ? d3.join(",") : "",
    ];
    const DOS = [Dos, dos1, dos2, dos3];
    // postData.insuranceName = patientinsurancename;
    // postData.Carries = patientinsurancename;
    if (data.statusType === "Secondary Pending") {
      postData.Carries = SecondarIsurancename;
      postData.insuranceName = SecondarIsurancename;
    } else {
      postData.Carries = patientinsurancename; // primary
      postData.insuranceName = patientinsurancename;
    }
    if (patientid > 0) {
      postData.patientName = Namee;
    } else {
      postData.patientName = Nameo;
    }

    const ProcedureIDs = [
      ProcedureID,
      ProcedureID1,
      ProcedureID2,
      ProcedureID3,
    ];
    const Code = [code, code1, code2, code3];
    const Charges = [charges, charges1, charges2, charges3];
    const UNits = [UNIT, UNIT1, UNIT2, UNIT3];
    postData.procedures = Code.filter((code, index) => code).map(
      (code, index) => ({
        code,
        charges: Charges[index] || null,
        dosTo: DOS[index] || null,
        dxPointer1: DiagnosisCode[index] || null,
        id: ProcedureIDs[index] || 0,
        claimId: claimId,
        units: UNits[index] || 0,
      })
    );
    axios
      .post(`${process.env.REACT_APP_API_URL}/claims/addclaims`, postData, {
        headers,
      })
      .then((response) => {
        setSubmitting(false);
        props.CloseModal();
        props.applyRefresh();
        setTimeout(() => {
          alert.success("Record saved successfully.", { type: "success" });
        }, 500);
      })
      .catch((error) => {
        setSubmitting(false);
        props.CloseModal();
        alert.error("Error saving record. Please try again.", {
          type: "error",
        });
      }, 500);
  };
  const [providerError, setProviderError] = useState(false);
  const [assignmentError, setAssignmentError] = useState("");

  const onSubmittoluxbilling = (data) => {
    const postData = {
      ...data,
      acceptAssignment: data.acceptAssignment === true ? true : "",
      dontAcceptAssignment: data.dontAcceptAssignment === true ? true : "",
      // secondaryPending: data.secondaryPending === true ? true : "",
      // secondaryPending: data.statusType || "",
    };

        const hasPrimary = patientinsurancename.trim() !== "";
    const hasSecondary = SecondarIsurancename.trim() !== "";

    if (!hasPrimary && !hasSecondary) {
      setInsuranceError("Please Go To Patient and Add Insurance First");
      return; // submit stop
    }
    setInsuranceError("");

    let isValid = true;
    if (!code) {
      setProcedureError("Procedure code is required.");
      isValid = false;
    } else {
      setProcedureError("");
    }

    if (d.length === 0) {
      setDiagnosisError("At least one diagnosis code is required.");
      isValid = false;
    } else {
      setDiagnosisError("");
    }

    if (!data.acceptAssignment && !data.dontAcceptAssignment) {
      setAssignmentError("Please select one option.");
       isValid = false;
    } else {
      setAssignmentError("");
    }
    if (!isValid) return;


    postData.totalCharges =
      (parseFloat(charges) || 0) +
      (parseFloat(charges1) || 0) +
      (parseFloat(charges2) || 0) +
      (parseFloat(charges3) || 0);
    postData.amountDue = data.totalCharges;
    postData.New = true;
    if (claimId > 0) {
      postData.amountDue = data.totalCharges;
    }
    postData.authNumber = AuthNumber;
    const DiagnosisCode = [
      Array.isArray(d) ? d.join(",") : "",
      Array.isArray(d1) ? d1.join(",") : "",
      Array.isArray(d2) ? d2.join(",") : "",
      Array.isArray(d3) ? d3.join(",") : "",
    ];
    const DOS = [Dos, dos1, dos2, dos3];
    setSubmitting(true);
    postData.submitted = true;
    postData.practiceId = data.practiceId;
    postData.claimsubmitted = true;
    if (!data.attendingPhysician) {
      setProviderError(true);
      setSubmitting(false);
      return;
    }

    postData.patientId = patientid > 0 ? patientid : selectpatientid;
    // postData.insuranceName = patientinsurancename;
    // postData.Carries = patientinsurancename;
    if (data.statusType === "Secondary Pending") {
      postData.Carries = SecondarIsurancename;
      postData.insuranceName = SecondarIsurancename;
    } else {
      postData.Carries = patientinsurancename; // primary
      postData.insuranceName = patientinsurancename;
    }
    const Code = [code, code1, code2, code3];
    const Charges = [charges, charges1, charges2, charges3];
    const UNits = [UNIT, UNIT1, UNIT2, UNIT3];
    const ProcedureIDs = [
      ProcedureID,
      ProcedureID1,
      ProcedureID2,
      ProcedureID3,
    ];

    postData.procedures = Code.filter((code, index) => code).map(
      (code, index) => ({
        code,
        charges: Charges[index] || null,
        dosTo: DOS[index] || null,
        dxPointer1: DiagnosisCode[index] || null,
        id: ProcedureIDs[index] || 0,
        claimId: claimId,
        units: UNits[index] || 0,
      })
    );

    console.log("This is post data", postData);
    axios
      .post(`${process.env.REACT_APP_API_URL}/claims/addclaims`, postData, {
        headers,
      })
      .then((response) => {
        setSubmitting(false);
        alert.success("Record saved successfully.", {
          type: "success",
          onClose: () => {
            props.CloseModal();
            props.applyRefresh();
          },
        });
      })
      .catch((error) => {
        setSubmitting(false);
        alert.success(`Error ${error.message}`, {
          type: "error",
        });
      });
  };

  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("success");
  const [DownLoadSubmiting, setDownLoadSubmiting] = useState(false);
  const download = (url) => {
    setSubmitting(true);
    setDownLoadSubmiting(true);
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/PatientDocument/DownloadAWSFile?path=${url}`,
        {
          headers,
          responseType: "blob",
        }
      )
      .then((res) => {
        // setopendocs(false)
        // setSpinner(false)
        setSubmitting(false);
        setDownLoadSubmiting(false);

        fileDownload(res, claimId + ".pdf");
      })
      .catch((err) => {
        setSubmitting(false);
        setDownLoadSubmiting(false);
        console.log(err);
      });
  };
  const onSubmitprint = async (value) => {
    setIsLoading(true);
    setDownLoadSubmiting(true);
    console.log(value);
    // const sendData = {
    //   ClaimId : claimId
    // }
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/claims/printClaims?ClaimId=${claimId}`,
        null,
        { headers }
      )
      .then((response) => {
        setSubmitting(false);
        setDownLoadSubmiting(false);
        setIsLoading(false);
        const message = response;

        if (message === "Patient Insurance Not Found") {
          setAlertMessage(message);
          setAlertSeverity("error");
        } else {
          setAlertMessage("Claim printed successfully.");
          setAlertSeverity("success");
          download(response);
        }
        // setAlertSeverity("success");
      })
      .catch((error) => {
        setSubmitting(false);
        setIsLoading(false);
        setDownLoadSubmiting(false);
        setAlertMessage(`Error: ${error.message}`);
        setAlertSeverity("error");
      });
  };

  const selectstyle = {
    height: "30px",
  };

  const gridRowStyle = {
    boxShadow: 2,
    border: 2,
    background: "white",
    fontSize: "13.6px !important",
    color: "black !important",
    borderColor: "rgba(5, 152, 236, 0.637) !important",
    "& .MuiDataGrid-cell:hover": {
      color: "rgba(5, 152, 236, 0.637) !important",
      fontSize: "14.6px !important",
    },
    "& .super-app-theme--header": {
      backgroundColor: "#A574FD",
      color: "white",
    },
  };
  const [providerr, setProvider] = useState();
  const [providers, setProviders] = useState([]);
  const [taxId, setTaxId] = useState("");
  const [npi, setNpi] = useState("");

  useEffect(() => {
    if (!claimPracticeID || claimPracticeID == practiceID) {
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/Providers/getPracticeProvider?parcticeid=${practiceID}`,
          { headers }
        )
        .then((response) => {
          var prov = [];
          response.forEach((field) => {
            prov.push({
              label: field.name,
              value: field.id,
              npi: field.npi,
              taxId: field.taxId,
            });
          });
          setProviders(prov);
        })
        .catch((error) => {});
    } else {
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/Providers/getPracticeProvider?patientid=${PatientidOfClaim}`,
          { headers }
        )
        .then((response) => {
          var prov = [];
          response.forEach((field) => {
            prov.push({
              label: `${field.firstName},${field.lastName}`,
              value: field.id,
              npi: field.nPI,
              taxId: field.taxId,
            });
          });
          setProviders(prov);
        })
        .catch((error) => {});
    }
  }, [practiceID, claimPracticeID, PatientidOfClaim]);
  const [referringProviderNpi, setReferringProviderNpi] = useState("");
  const attendingPhysician = watch("attendingPhysician");
  useEffect(() => {
    if (attendingPhysician && providers.length > 0) {
      const selectedProvider = providers.find(
        (option) => option.value === attendingPhysician
      );
      if (selectedProvider) {
        setNpi(selectedProvider.npi);
        setTaxId(selectedProvider.taxId);
      }
    }
  }, [attendingPhysician, providers]);
  const [referringPhysician, setReferringPhysician] = useState("");
  useEffect(() => {
    if (selectpatientid || patientid) {
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/AutherizationRequest/getProviderFromVOB?patientId=${selectpatientid ? selectpatientid :patientid}`,
          { headers }
        )
        .then((response) => {
          if (response.success) {
            setValue("referringPhysician", response.referringProvider);
            setReferringPhysician(response.referringProvider);
          } else {
            setValue("referringPhysician", "");
          }
        })
        .catch((error) => {
          console.error("Error fetching authorization:", error);
        });
    }
  }, [selectpatientid,patientid]);
  const refProvider = watch("referringPhysician");
  useEffect(() => {
    if (referringPhysician && referringPhysician.length > 0) {
      const selected = referringPhysicianName.find(
        (p) => String(p.value) === String(referringPhysician)
      );
      if (selected) {
        setReferringProviderNpi(selected.npi);
        console.log("testingNpi", selected);
      }
    }
  }, [referringPhysicianName, referringPhysician]);

  const clearSelection = (e) => {
    setValue("patientName", "");
    setPatientData([]);
    setPatient(false);
    setPatientNamee("");
    setSearchText("");
    setselectpatientid("");
    setRefresh(true);
    onChangeHandle(e.target.value);
  };
  const [VOBError, setVOBError] = useState(false);

  const ImportVOB = () => {
    const idToUse = patientid > 0 ? patientid : selectpatientid; // Use patientId if greater than 0

    if (!idToUse || !Dos) {
      setVOBError(true);
      return;
    }

    setVOBError(false);

    axios
      .get(
        `${process.env.REACT_APP_API_URL}/AutherizationRequest/CheckDosDate?patientId=${idToUse}&dosDate=${Dos}`,
        { headers }
      )
      .then((response) => {
        if (response.status !== 204) {
          setAuthNumber(response);
        }
      })
      .catch((error) => {
        console.error("Error fetching authorization:", error);
      });
  };

  useEffect(() => {
    const idToUse = patientid > 0 ? patientid : selectpatientid;
    if (idToUse && Dos) {
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/AutherizationRequest/CheckDosDate?patientId=${idToUse}&dosDate=${Dos}`,
          { headers }
        )
        .then((response) => {
          if (response.status !== 204) {
            setAuthNumber(response);
          }
        })
        .catch((error) => {
          console.error("Error fetching authorization:", error);
        });
    }
  }, [patientid, selectpatientid, Dos]);

  const alertStyles = {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translateX(-50%)",
    zIndex: 1050,
    width: "80%",
    maxWidth: "400px",
  };

  useEffect(() => {
    if (alertMessage) {
      const timer = setTimeout(() => {
        setAlertMessage("");
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [alertMessage]);

  const onSubmitPending = (data) => {
    const postData = {
      ...data,
      acceptAssignment: data.acceptAssignment === true ? true : "",
      dontAcceptAssignment: data.dontAcceptAssignment === true ? true : "",
      // secondaryPending: data.secondaryPending === true ? true : "",
      // secondaryPending: data.statusType || "",
    };
        const hasPrimary = patientinsurancename.trim() !== "";
    const hasSecondary = SecondarIsurancename.trim() !== "";

    if (!hasPrimary && !hasSecondary) {
      setInsuranceError("Please Go To Patient and Add Insurance First");
      return; // submit stop
    }
    setInsuranceError("");
    let isValid = true;
    if (!code) {
      setProcedureError("Procedure code is required.");
      isValid = false;
    } else {
      setProcedureError("");
    }

    if (d.length === 0) {
      setDiagnosisError("At least one diagnosis code is required.");
      isValid = false;
    } else {
      setDiagnosisError("");
    }
 if (!data.acceptAssignment && !data.dontAcceptAssignment) {
      setAssignmentError("Please select one option.");
      isValid = false;
    }else {
        setAssignmentError("");
    }
    if (!isValid) return;

  
    postData.totalCharges =
      (parseFloat(charges) || 0) +
      (parseFloat(charges1) || 0) +
      (parseFloat(charges2) || 0) +
      (parseFloat(charges3) || 0);
    if (claimId > 0) {
      postData.amountDue = data.totalCharges;
    }
    const DiagnosisCode = [
      Array.isArray(d) ? d.join(",") : "",
      Array.isArray(d1) ? d1.join(",") : "",
      Array.isArray(d2) ? d2.join(",") : "",
      Array.isArray(d3) ? d3.join(",") : "",
    ];
    const DOS = [Dos, dos1, dos2, dos3];
    setSubmitting(true);
    postData.submitted = true;
    postData.compeleted = false;
    postData.payment = false;
    postData.practiceId = data.practiceId;
    postData.claimsubmitted = true;
    if (!data.attendingPhysician) {
      setProviderError(true);
      setSubmitting(false);
      return;
    }

    const Code = [code, code1, code2, code3];
    const Charges = [charges, charges1, charges2, charges3];
    const UNits = [UNIT, UNIT1, UNIT2, UNIT3];
    const ProcedureIDs = [
      ProcedureID,
      ProcedureID1,
      ProcedureID2,
      ProcedureID3,
    ];
    postData.procedures = Code.filter((code, index) => code).map(
      (code, index) => ({
        code,
        charges: Charges[index] || null,
        dosTo: DOS[index] || null,
        dxPointer1: DiagnosisCode[index] || null,
        id: ProcedureIDs[index] || 0,
        claimId: claimId,
        units: UNits[index] || 0,
      })
    );
    if (data.statusType === "Secondary Pending") {
      postData.Carries = SecondarIsurancename;
      postData.insuranceName = SecondarIsurancename;
    } else {
      postData.Carries = patientinsurancename; // primary
      postData.insuranceName = patientinsurancename;
    }
    axios
      .post(`${process.env.REACT_APP_API_URL}/claims/addclaims`, postData, {
        headers,
      })
      .then((response) => {
        setSubmitting(false);
        props.CloseModal();
        props.applyRefresh();
        setTimeout(() => {
          alert.success("Record saved successfully.", { type: "success" });
        }, 500);
      })
      .catch((error) => {
        setSubmitting(false);
        props.CloseModal();
        alert.error("Error saving record. Please try again", { type: "error" });
      }, 500);
  };
  const [Messages, setMessages] = useState(false);
  const handleMessages = () => {
    setMessages(true);
  };

  const handleCloseMessages = () => {
    setMessages(false);
    settext("");
    setshowToFrontOffice(false);
  };
  const modalstyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "600px", // Width increase
    height: "340px", // Fixed height
    bgcolor: "white",
    border: "2px solid #3C78C7",
    boxShadow: 24,
    borderRadius: "8px",
    zIndex: 300000,
  };
  const Messagestyle = {
    position: "absolute",
    top: "57%",
    left: "52%",
    transform: "translate(-50%, -50%)",
    width: "570px",
    height: "72vh",
    overflowY: "auto", // Enable vertical scroll
    borderRadius: "8px",
    padding: 2,
    zIndex: 300000,
  };

  const [MessagesData, setMessagesData] = useState(null);
  const [showToFrontOffice, setshowToFrontOffice] = useState(false);
  const [text, settext] = useState("");
  const OnSubmitMessage = () => {
    const payload = {
      text: text,
      showToFrontOffice: showToFrontOffice,
      claimId: claimId,
    };

    axios
      .post(
        `${process.env.REACT_APP_API_URL}/claims/AddEditClaimMessages`,
        payload,
        { headers }
      )
      .then((response) => {
        if (response) {
          handleCloseMessages();
          setTimeout(() => {
            alert.success("Message saved successfully.", { type: "success" });
          }, 500);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        alert.error("Something went wrong!", { type: "error" });
      });
  };
  const handleGenerateClaims = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/Batches/generateBatchFromClaimIds`,
        [claimId],
        { headers }
      );

      const data = response;
      await Swal.fire({
        icon: data.success ? "success" : "error",
        title: data.success
          ? "Batch Generated Successfully!"
          : "Batch Generation Failed",
        width: "520px",
        padding: "1.5rem",
        background: "#f9fafb",
        color: "#111",
        html: `
          <div style="text-align: left; font-size: 15px; line-height: 1.6; margin-top: 10px;">
            <div style="background: #ffffff; padding: 12px 15px; border-radius: 10px; border: 1px solid #e5e7eb;">
              <p><b style="color:#374151;">Message:</b> ${data.message}</p>
              <p><b style="color:#374151;">Batch ID:</b> ${
                data.batchId || "N/A"
              }</p>
              <p><b style="color:#374151;">Total Claims:</b> ${
                data.totalClaims || "0"
              }</p>
            </div>
  
            ${
              data.success
                ? `
                <div style="margin-top: 20px; display:flex; justify-content:center; gap:12px;">
                  <button id="downloadBtn"
                    style="
                      background: #2563eb;
                      color: white;
                      border: none;
                      padding: 10px 18px;
                      border-radius: 8px;
                      cursor: pointer;
                      font-size: 14px;
                      font-weight: 600;
                    "
                  >
                    📥 Download EDI
                  </button>
  
                  <button id="uploadBtn"
                    style="
                      background: #059669;
                      color: white;
                      border: none;
                      padding: 10px 18px;
                      border-radius: 8px;
                      cursor: pointer;
                      font-size: 14px;
                      font-weight: 600;
                    "
                  >
                    ☁ Upload to Clearing House
                  </button>
                </div>
              `
                : ""
            }
          </div>
        `,
        showConfirmButton: false,
        didRender: () => {
          // 💥 Z-INDEX FIX HERE
          const el = document.querySelector(".swal2-container");
          if (el) el.style.zIndex = 1800;

          const downloadBtn = document.getElementById("downloadBtn");
          if (downloadBtn) {
            downloadBtn.addEventListener("click", async () => {
              await handleDownloadEdiFile(data.ediFilePath);
            });
          }

          const uploadBtn = document.getElementById("uploadBtn");
          if (uploadBtn) {
            uploadBtn.addEventListener("click", async () => {
              uploadClaims(data.ediFilePath);
            });
          }
        },
      });
    } catch (error) {
      console.error("There was an error!", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "An error occurred while generating the batch. Please try again.",
        didRender: () => {
          const el = document.querySelector(".swal2-container");
          if (el) el.style.zIndex = 1800;
        },
      });
    } finally {
    }
  };

  const uploadClaims = async (filePath) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/Batches/uploadBatchFile?batchURL=${filePath}`,
        {},
        { headers, responseType: "text" }
      );

      const xmlString = response;
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(xmlString, "text/xml");

      // ------- Check <claim> & <messages> -------
      const claimNode = xmlDoc.querySelector("result > claim");
      const messagesNode = claimNode?.querySelector("messages");

      const mesgid = messagesNode?.getAttribute("mesgid"); // ACK / NACK
      const message = messagesNode?.getAttribute("message"); // Description
      const errorDetail = messagesNode?.getAttribute("error"); // validation error message

      // ---------------- SUCCESS CASE ----------------
      if (mesgid === "ACK" && message === "Acknowledged") {
        Swal.fire({
          icon: "success",
          title: "Upload Successful",
          html: `
            <b>Claims uploaded successfully!</b><br/><br/>
            ClaimMD Response: <span style="color:green">ACK - Acknowledged</span>
          `,
          didRender: () => {
            const el = document.querySelector(".swal2-container");
            if (el) el.style.zIndex = 1800;
          },
        });
        return;
      }

      // ---------------- VALIDATION ERROR CASE (NACK) ----------------
      if (mesgid === "NACK") {
        Swal.fire({
          icon: "warning",
          title: "Validation Error",
          html: `
            <div style="text-align:left;">
              <b>ClaimMD Validation Failed</b><br/><br/>
              <b>Message:</b> ${message || "Validation error"}<br/>
              <b>Details:</b> ${errorDetail || "No additional details"}
            </div>
          `,
          didRender: () => {
            const el = document.querySelector(".swal2-container");
            if (el) el.style.zIndex = 1800;
          },
        });
        return;
      }

      // ---------------- ERROR NODE <error> ----------------
      const errorNode = xmlDoc.querySelector("result > error");
      if (errorNode) {
        const errorMesg =
          errorNode.getAttribute("error_mesg") || "Unknown error";

        Swal.fire({
          icon: "error",
          title: "Upload Failed",
          html: `
            <div style="text-align:left;">
              <b>ClaimMD Error:</b><br/><br/>
              ${errorMesg}
            </div>
          `,
          didRender: () => {
            const el = document.querySelector(".swal2-container");
            if (el) el.style.zIndex = 1800;
          },
        });
        return;
      }

      // ---------------- UNKNOWN RESPONSE ----------------
      Swal.fire({
        icon: "warning",
        title: "Unexpected Response",
        html: `
          ClaimMD returned an unrecognized format.<br/><br/>
          <pre style="background:#f3f4f6;padding:10px;border-radius:5px;">
  ${xmlString}
          </pre>
        `,
        didRender: () => {
          const el = document.querySelector(".swal2-container");
          if (el) el.style.zIndex = 1800;
        },
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Upload Error",
        text: "Upload failed: " + error.message,
        didRender: () => {
          const el = document.querySelector(".swal2-container");
          if (el) el.style.zIndex = 1800;
        },
      });
    }
  };

  const handleDownloadEdiFile = async (filePath) => {
    try {
      const encodedPath = encodeURIComponent(filePath);
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/PatientDocument/DownloadAWSFile?path=${encodedPath}`,
        {
          headers,
          responseType: "blob",
        }
      );

      const filename = filePath.split("/").pop() || `Batch_${Date.now()}.txt`;
      fileDownload(response, filename);

      Swal.fire({
        icon: "success",
        title: "Download Complete",
        text: `EDI file "${filename}" downloaded successfully!`,
        didRender: () => {
          const el = document.querySelector(".swal2-container");
          if (el) el.style.zIndex = 1800;
        },
      });
    } catch (error) {
      console.error("Error downloading EDI file:", error);
      Swal.fire({
        icon: "error",
        title: "Download Failed",
        text: "Could not download the EDI file.",
        didRender: () => {
          const el = document.querySelector(".swal2-container");
          if (el) el.style.zIndex = 1800;
        },
      });
    }
  };

  const onSubmitEdi = (data) => {
    const postData = {
      ...data,
      acceptAssignment: data.acceptAssignment === true ? true : "",
      dontAcceptAssignment: data.dontAcceptAssignment === true ? true : "",
    };
    postData.payment = data.payment;
    postData.authNumber = AuthNumber;
    postData.practiceId = data.practiceId;
    postData.patientName = Namee;
    postData.compeleted = data.compeleted;
    postData.patientId = patientid > 0 ? patientid : selectpatientid;
    postData.totalCharges =
      (parseFloat(charges) || 0) +
      (parseFloat(charges1) || 0) +
      (parseFloat(charges2) || 0) +
      (parseFloat(charges3) || 0);
    if (claimId > 0) {
      postData.amountDue = data.totalCharges;
    }
    const DiagnosisCode = [
      Array.isArray(d) ? d.join(",") : "",
      Array.isArray(d1) ? d1.join(",") : "",
      Array.isArray(d2) ? d2.join(",") : "",
      Array.isArray(d3) ? d3.join(",") : "",
    ];
    const DOS = [Dos, dos1, dos2, dos3];

    if (data.statusType === "Secondary Pending") {
      postData.Carries = SecondarIsurancename;
      postData.insuranceName = SecondarIsurancename;
    } else {
      postData.Carries = patientinsurancename; // primary
      postData.insuranceName = patientinsurancename;
    }
    if (patientid > 0) {
      postData.patientName = Namee;
    } else {
      postData.patientName = Nameo;
    }

    const ProcedureIDs = [
      ProcedureID,
      ProcedureID1,
      ProcedureID2,
      ProcedureID3,
    ];
    const Code = [code, code1, code2, code3];
    const Charges = [charges, charges1, charges2, charges3];
    const UNits = [UNIT, UNIT1, UNIT2, UNIT3];
    postData.procedures = Code.filter((code, index) => code).map(
      (code, index) => ({
        code,
        charges: Charges[index] || null,
        dosTo: DOS[index] || null,
        dxPointer1: DiagnosisCode[index] || null,
        id: ProcedureIDs[index] || 0,
        claimId: claimId,
        units: UNits[index] || 0,
      })
    );
    axios
      .post(`${process.env.REACT_APP_API_URL}/claims/addclaims`, postData, {
        headers,
      })
      .then((response) => {
        handleGenerateClaims();
      })
      .catch((error) => {
        setSubmitting(false);
      });
  };

  const [showDropdown, setShowDropdown] = useState(false);
  const [userList, setUserList] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/Users/getUsers`, { headers })
      .then((response) => {
        var prov = [];
        response.forEach((field) => {
          prov.push({
            label: field.fullName,
            value: field.id,
          });
        });
        setUserList(prov);
      })
      .catch((error) => {});
  }, [showDropdown]);
  const handleSendEmail = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/claims/sendClaimEmail?userId=${selectedUser}&patientId=${claimId}`,
        null,
        { headers }
      );

      Swal.fire({
        icon: "success",
        title: "Email sent successfully",
        didRender: () => {
          const el = document.querySelector(".swal2-container");
          if (el) el.style.zIndex = 1800;
        },
      });
    } catch (err) {
      console.error(err);
      Swal.fire({
        icon: "error",
        title: "Failed to send email.",
        didRender: () => {
          const el = document.querySelector(".swal2-container");
          if (el) el.style.zIndex = 1800;
        },
      });
    }
  };
  useEffect(() => {
    if (selectedUser) {
      handleSendEmail();
    }
  }, [selectedUser]);
  const [openPreview, setOpenPreview] = useState(false);

  const handleOpenPreview = () => setOpenPreview(true);
  const handleClosePreview = () => setOpenPreview(false);
  return (
    <React.Fragment>
      <div>
        <Modal open={openPreview} onClose={handleClosePreview}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "70%",
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 3,
              borderRadius: "12px",
              maxHeight: "90vh",
              overflowY: "auto",
            }}
          >
            <PreviewClaim
              claimId={claimId}
              handleClosePreview={handleClosePreview}
            />
          </Box>
        </Modal>

        <Modal
          open={Messages}
          onClose={handleCloseMessages}
          className="glassmorphic-card"
        >
          <Box sx={modalstyle}>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} xl={12}>
                <Headroom>
                  <Grid
                    container
                    style={{
                      backgroundColor: "#356F60",
                      position: "sticky",
                      padding: "6px",
                      borderRadius: "5px 3px 0 0",
                    }}
                  >
                    <Grid item xs={11} sm={11} xl={11}>
                      <Typography
                        style={{
                          color: "white",
                          fontWeight: "600",
                          textDecoration: "underline",
                          fontSize: "18px",
                        }}
                      >
                        Add Messages
                      </Typography>
                    </Grid>
                    <Grid item xs={1} sm={1} xl={1}>
                      <CancelOutlinedIcon
                        style={{
                          color: "red",
                          cursor: "pointer",
                          float: "right",
                        }}
                        onClick={handleCloseMessages}
                      />
                    </Grid>
                  </Grid>
                </Headroom>
              </Grid>
            </Grid>
            <Grid container spacing={1} p={2}>
              <Grid item xs={12}>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  <Checkbox
                    value={showToFrontOffice}
                    onChange={(e) => {
                      setshowToFrontOffice(e.target.checked);
                    }}
                    style={{ color: "green", cursor: "pointer" }}
                  />
                  <Typography
                    style={{
                      fontWeight: "bold",
                      cursor: "pointer",
                      color: "#377562",
                      transition: "0.3s",
                    }}
                    onClick={() => setshowToFrontOffice(!showToFrontOffice)} // Click text to toggle checkbox
                  >
                    Show to Front Office
                  </Typography>
                </div>
              </Grid>

              <Grid item xs={12}>
                <InputLabel>Message</InputLabel>
                <Controller
                  name="text"
                  {...register("text")}
                  control={control}
                  render={({ field }) => (
                    <TextareaAutosize
                      aria-label="minimum height"
                      minRows={2}
                      placeholder="Enter Messages"
                      style={{
                        width: "100%",
                        borderRadius: "8px",
                        border: "2px solid #black",
                        height: "40px",
                      }}
                      value={text}
                      onChange={(e) => settext(e.target.value)}
                      fullWidth
                    />
                  )}
                />
              </Grid>
              <Grid item xs={8}></Grid>
              <Grid item xs={4}>
                <Button
                  className="Button"
                  variant="gradient"
                  fullWidth
                  onClick={OnSubmitMessage}
                  style={{
                    marginTop: "0px",
                    marginBottom: "55px",
                    float: "right",
                    padding: "5px",
                    height: "35px",
                    // backgroundColor: '#A574FD',
                    color: "white",
                    fontSize: "12px",
                  }}
                >
                  <SaveOutlinedIcon
                    fontSize="medium"
                    style={{
                      color: "white",
                      paddingBottom: "2px",
                    }}
                  ></SaveOutlinedIcon>
                  Save Message
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Modal>

        {alertMessage && (
          <div style={alertStyles}>
            <Alert
              severity={alertSeverity}
              onClose={() => setAlertMessage("")} // Close alert on click
              style={{
                width: "100%",
                transition: "opacity 0.5s ease-in-out",
              }}
            >
              {alertMessage}
            </Alert>
          </div>
        )}
        <Container>
          <Grid
            container
            spacing={2}
            sx={{ display: "flex", marginTop: "10px" }}
          >
            <Grid item md={4} sm={6} xs={12}>
              <Typography style={{ fontSize: "17px", fontWeight: "bold" }}>
                Provider rendering services (Name):
              </Typography>

              <Controller
                name="attendingPhysician"
                // onChange={value => setProvider('provider_id', value)}
                {...register("attendingPhysician")}
                control={control}
                render={({ field }) => (
                  <ReactSelect
                    {...field}
                    default
                    size="small"
                    style={{
                      width: "50%",
                    }}
                    value={providers.find(
                      (option) =>
                        option.value == getValues("attendingPhysician")
                    )}
                    onChange={(value) => {
                      setValue("attendingPhysician", value.value);
                      setNpi(value.npi);
                      setTaxId(value.taxId);
                      setProviderError(false);
                    }}
                    options={providers}
                  />
                )}
              />

              {providerError && (
                <p
                  style={{
                    color: "red",
                    fontSize: "14px",
                    whiteSpace: "nowrap",
                  }}
                >
                  Please select Provider.
                </p>
              )}
            </Grid>

            <Grid item md={4} sm={6} xs={12}>
              <Typography
                style={{
                  fontSize: "17px",
                  fontWeight: "bold",
                  whiteSpace: "nowrap",
                }}
              >
                Service Provider TIN:
              </Typography>
              <TextField
                value={taxId}
                onChange={(e) => {
                  setTaxId(e.target.value);
                }}
                InputProps={{ readOnly: true }}
                size="small"
                fullWidth
                disabled
              />
            </Grid>

            <Grid item md={4} sm={6} xs={12}>
              <Typography
                style={{
                  fontSize: "17px",
                  fontWeight: "bold",
                  whiteSpace: "nowrap",
                }}
              >
                Service Provider NPI:
              </Typography>
              <TextField
                value={npi}
                onChange={(e) => {
                  setNpi(e.target.value);
                }}
                InputProps={{ readOnly: true }}
                size="small"
                fullWidth
                disabled
              />
            </Grid>

            <Grid item md={4} sm={6} xs={12}>
              <Typography style={{ fontSize: "18px" }}>
                Patient Last Name:
              </Typography>
              <ClickAwayListener onClickAway={() => setPatient(false)}>
                <TextField
                  {...register("patientName")}
                  size="small"
                  autoComplete="off"
                  style={{ width: "99%" }}
                  placeholder="Enter Patient Last Name"
                  {...(patientid > 0 ? { value: Namee } : {})}
                  {...(patientid < 0 ? { value: Nameo } : {})}
                  InputProps={{
                    readOnly: claimId > 0,
                    endAdornment: claimId == 0 && (
                      <InputAdornment position="end">
                        {selectpatientid > 0 && patientid == 0 ? (
                          <CancelOutlinedIcon
                            style={{ color: "red", cursor: "pointer" }}
                            onClick={clearSelection}
                          />
                        ) : (
                          ""
                        )}
                      </InputAdornment>
                    ),
                  }}
                  onKeyUp={(ev) => {
                    console.log("ee:", ev.target.value);
                    setSearchText(ev.target.value);
                    setPatientData([]);
                    if (
                      ev.target.value !== null &&
                      ev.target.value !== "" &&
                      ev.target.value.length > 0
                    ) {
                      onChangeHandle(ev.target.value);
                    } else {
                      setPatient(false);
                    }
                  }}
                  error={errors.patientName}
                  helperText={
                    errors.patientName ? errors.patientName.message : ""
                  }
                />
              </ClickAwayListener>
              {isLoading && (
                <CircularProgress size={20} style={{ marginLeft: "-40px" }} />
              )}
              {patient ? (
                <div
                  className="col-xs-6"
                  style={{
                    height: 150,
                    overflowY: "scroll",
                    padding: "14px 16px",
                    fontSize: "0.875rem",
                    color: "#67748e",
                    borderRadius: "5px",
                    background: "white",
                    textAlign: "justify",
                    textJustify: "inter-word",
                    position: "absolute",
                    zIndex: "99",
                    width: "39%",
                    border: "1px solid #6cb5f9",
                  }}
                >
                  {patient ? (
                    patientData.length > 0 ? (
                      patientData.map((s, index) => {
                        var pat = `${patientData[index].lastName}, ${patientData[index].firstName}`;

                        const searchTextLower = searchText.toLowerCase();
                        const fullNameLower = pat.toLowerCase();
                        const i = fullNameLower.indexOf(searchTextLower);

                        if (i === -1) {
                          return null;
                        }

                        const p1 = pat.substring(0, i);
                        const p = pat.substring(i, i + searchText.length);
                        const p2 = pat.substring(i + searchText.length);

                        return (
                          <>
                            <p
                              style={patientListStyle}
                              onClick={(e) => {
                                setValue(
                                  "patientName",
                                  `${patientData[index].lastName}, ${patientData[index].firstName}`
                                );
                                setValue(
                                  "patientName",
                                  `${patientData[index].lastName}, ${patientData[index].firstName}`
                                );
                                setPatientData([]);
                                setPatient(false);
                                setPatientNamee(
                                  `${patientData[index].lastName}, ${patientData[index].firstName}`
                                );
                                setselectpatientid(patientData[index].id);
                              }}
                              onBlur={(e) => {
                                setPatientData([]);
                                setPatient(false);
                              }}
                              onChange={(e) => {
                                setPatientData([]);
                                setPatient(false);
                                setPatientNamee("");
                              }}
                            >
                              <span>{p1}</span>
                              <span style={{ backgroundColor: "yellow" }}>
                                {p}
                              </span>
                              <span>{p2}</span>
                            </p>
                          </>
                        );
                      })
                    ) : (
                      <Typography>No Record found</Typography>
                    )
                  ) : null}
                </div>
              ) : (
                ""
              )}
            </Grid>

            <Grid item md={4} sm={6} xs={12}>
              <Typography style={{ fontSize: "18px" }}>DOB:</Typography>
              <TextField
                size="small"
                name="dob"
                fullWidth
                type="date"
                value={patientDOB}
                disabled
                inputProps={{
                  readOnly: true, // Corrected prop name
                }}
              />
            </Grid>

            <Grid item md={4} sm={6} xs={12}>
              <Typography style={{ fontSize: "18px" }}>Address:</Typography>
              <TextField
                style={{ width: "99%" }}
                size="small"
                fullWidth
                name="address"
                disabled
                value={patientiaddress}
                inputProps={{
                  readOnly: true, // Corrected prop name
                }}
              />
            </Grid>

            <Grid item md={4} sm={6} xs={12}>
              <Typography style={{ fontSize: "18px" }}>
                {" "}
                Referring Physician:-{" "}
              </Typography>
              <Controller
                name="referringPhysician"
                {...register("referringPhysician")}
                control={control}
                render={({ field }) => (
                  <ReactSelect
                    {...field}
                    fullWidth
                    value={referringPhysicianName.find(
                      (option) =>
                        String(option.value) === String(referringPhysician)
                    )}
                    onChange={(value) => {
                      setValue(
                        "referringPhysician",
                        value != null ? value.value : ""
                      );
                      setReferringProviderNpi(value.npi);
                    }}
                    options={referringPhysicianName}
                  />
                )}
              />
            </Grid>

            <Grid item md={4} sm={6} xs={12}>
              <Typography style={{ fontSize: "18px" }}>
                Referring Provider NPI:
              </Typography>

              <TextField
                size="small"
                fullWidth
                value={referringProviderNpi}
                onChange={(e) => {
                  setReferringProviderNpi(e.target.value);
                }}
                disabled
                InputProps={{ readOnly: true }}
              />
            </Grid>

            <Grid item md={12} sm={12} xs={12}>
              <Typography
                style={{
                  fontSize: "20px",
                  fontWeight: "bold",
                  textDecoration: "underline",
                }}
              >
                Primary Insurance
              </Typography>
            </Grid>

            <Grid item md={6} sm={6} xs={12}>
              <Typography style={{ fontSize: "18px" }}> Insurance</Typography>
              <Controller
                name="insuranceName"
                {...register("insuranceName")}
                control={control}
                render={({ field }) => (
                  <TextField
                    InputProps={{
                      readOnly: true,
                    }}
                    size="small"
                    {...field}
                    fullWidth
                    value={patientinsurancename}
                    onChange={(e) => {
                      setValue("insuranceName", e.target.value);
                      setValue("Carries", e.target.value);
                      setpatientinsurancename(e.target.value);
                    }}
                    disabled
                    inputProps={{
                      readOnly: true, // Corrected prop name
                    }}
                  />
                )}
              />
              {insuranceError && (
           <Typography
                  style={{
                    color: "red",
                    fontSize: "14px",
                    whiteSpace: "nowrap",
                  }}
                >
                {insuranceError}
              </Typography>
            )}
            </Grid>

            <Grid item md={6} sm={6} xs={12}>
              <Typography style={{ fontSize: "18px" }}>Member ID:</Typography>
              <TextField
                size="small"
                value={memberid}
                fullWidth
                onChange={(e) => {
                  setmemeberid(e.target.value);
                }}
                disabled
                inputProps={{
                  readOnly: true, // Corrected prop name
                }}
              />
            </Grid>
            

            <Grid item md={12} sm={12} xs={12}>
              <Typography
                style={{
                  fontSize: "20px",
                  fontWeight: "bold",
                  textDecoration: "underline",
                }}
              >
                Secondary Insurance
              </Typography>
            </Grid>

            <Grid item md={6} sm={6} xs={12}>
              <Typography style={{ fontSize: "18px" }}> Insurance</Typography>
              <TextField
                size="small"
                fullWidth
                value={SecondarIsurancename}
                disabled
                inputProps={{
                  readOnly: true,
                }}
              />
            </Grid>

            <Grid item md={6} sm={6} xs={12}>
              <Typography style={{ fontSize: "18px" }}>Member ID:</Typography>
              <TextField
                size="small"
                value={SecondarMemberid}
                fullWidth
                disabled
                inputProps={{
                  readOnly: true, // Corrected prop name
                }}
              />
            </Grid>

            <Grid item md={6} sm={6} xs={12}>
              <Typography style={{ fontSize: "18px" }}>DOS:</Typography>

              <Controller
                name="dos"
                control={control}
                render={({ field }) => (
                  <TextField
                    size="small"
                    style={{ width: "99%" }}
                    {...field}
                    name="dos"
                    type="date"
                    value={Dos}
                    onChange={(e) => {
                      setValue("dos", e.target.value);
                      setDOS(e.target.value);
                      setdos(e.target.value);
                    }}
                    
                   error={!!errors.dos} 
      helperText={errors.dos ? errors.dos.message : ""} 

                  />
                )}
              />
              {/* <p style={{ color: "red", fontSize: "14px" }}>
                {errors.dos?.message}
              </p> */}
            </Grid>

            <Grid item md={6} sm={6} xs={12}>
              <Typography style={{ fontSize: "18px" }}>
                Authorization Number:
              </Typography>

              <Controller
                name="authNumber"
                {...register("authNumber")}
                control={control}
                render={({ field }) => (
                  <TextField
                    size="small"
                    value={AuthNumber}
                    style={{ width: "99%" }}
                    onChange={(e) => {
                      setValue("authNumber", e.target.value);
                      setAuthNumber(e.target.value);
                    }}
                  />
                )}
              />
            </Grid>

            {/* <Grid
              item
              md={12}
              sm={12}
              xs={12}
              style={{
                padding: "15px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Button
                className="Button"
                variant="gradient"
                onClick={ImportVOB}
                style={{
                  margin: "10px",
                  width: "240px",
                  height: "35px",
                  color: "white",
                  fontSize: "14px",
                }}
              >
                Import from VOB
              </Button>
              {VOBError && (
                <p style={{ color: "red", fontSize: "14px" }}>
                  Please Select Patient and DOS First
                </p>
              )}
            </Grid> */}
            <Grid
              item
              md={12}
              sm={12}
              xs={12}
              style={{
                padding: "15px",
                display: "flex",
                justifyContent: "flex-end", // Aligns items to the right
                alignItems: "center",
              }}
            >
              <Button
                className="Button"
                variant="gradient"
                onClick={ImportVOB}
                style={{
                  margin: "10px",
                  width: "240px",
                  height: "40px",
                  color: "white",
                  fontSize: "14px",
                }}
              >
                Fetch Auth Number from VOB
              </Button>
              {VOBError && (
                <p
                  style={{ color: "red", fontSize: "14px", marginLeft: "10px" }}
                >
                  Please Select Patient and DOS First
                </p>
              )}
            </Grid>

            <Grid xs={12}>
              <Typography
                level="h1"
                style={{
                  padding: "auto",
                  textAlign: "center",
                  fontSize: "35px",
                  fontWeight: "bold",
                  textDecoration: "underline",
                }}
              >
                Claim details you wish to submit
              </Typography>
            </Grid>

            {/* <Container>
              <Grid
                container
                spacing={2}
                sx={{ display: "flex", marginTop: "10px" }}
              > */}
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <Typography
                style={{ fontSize: "16px", textDecoration: "underline" }}
              >
                Procedure code:
              </Typography>

              <Controller
                name="cpt1"
                {...register("cpt1")}
                control={control}
                 rules={{ required: "Procedure code is required" }} 
                render={({ field ,fieldState }) => {
                  const selectedOption = procedureCode1List.find(
                    (option) => option.value == code
                  );
                  const fallbackOption = { label: code, value: code };
                  return (
                    <ReactSelect
                      {...field}
                      fullWidth
                      value={selectedOption || fallbackOption}
                      onChange={(e) => {
                        setcode(e.value);
                        setcharges(e.qasim);
                        setValue("cpt1", e.value);
                        setUNIT(e.unit);
                      }}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          width: "99%",
                        }),
                      }}
                      options={procedureCode1List}
                    />
                  );
                }}
              />
              {procedureError && (
                <Typography color="error" style={{ fontSize: "14px" }}>
                  {procedureError}
                </Typography>
              )}
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={3}>
              <Typography
                style={{ fontSize: "16px", textDecoration: "underline" }}
              >
                Diagnosis code:
              </Typography>

              <Controller
                name="dx1"
                {...register("dx1")}
                control={control}
                render={({ field }) => {
                  const selectedOptions = d.map((code) => {
                    const found = diagnosisList.find(
                      (option) => String(option.value) === String(code)
                    );
                    return found || { label: code, value: code }; // fallback if not found
                  });

                  return (
                    <ReactSelect
                      {...field}
                      fullWidth
                      isMulti={true}
                      value={selectedOptions}
                      onChange={(selectedOptions) => {
                        const selectedValues =
                          selectedOptions?.map((opt) => String(opt.value)) ||
                          []; // Ensure consistent type
                        setd(selectedValues);
                      }}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          width: "99%",
                        }),
                      }}
                      options={diagnosisList}
                    />
                  );
                }}
              />
              {diagnosisError && (
                <Typography color="error" style={{ fontSize: "14px" }}>
                  {diagnosisError}
                </Typography>
              )}
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={3}>
              <Typography
                style={{ fontSize: "16px", textDecoration: "underline" }}
              >
                DOS
              </Typography>

              <Controller
                name="dos"
                margin="dense"
                {...register("dos")}
                control={control}
                render={({ field }) => (
                  <TextField
                    size="small"
                    {...field}
                    style={{ width: "99%" }}
                    type="date"
                    // value={dos ? dos : ''}
                    value={Dos}
                    onChange={(e) => {
                      setValue("dos", e.target.value);
                      setDOS(e.target.value);
                      setdos(e.target.value);
                    }}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={3}>
              <Typography
                style={{ fontSize: "16px", textDecoration: "underline" }}
              >
                Charge $
              </Typography>
              <Controller
                name="charges1"
                margin="dense"
                {...register("charges1")}
                control={control}
                render={({ field }) => (
                  <TextField
                    size="small"
                    {...field}
                    style={{ width: "99%" }}
                    value={charges}
                    onChange={(e) => {
                      setValue("charges1", e.target.value);
                    }}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={3}>
              <Typography
                style={{ fontSize: "16px", textDecoration: "underline" }}
              >
                Procedure code:
              </Typography>

              <Controller
                name="cpt2"
                {...register("cpt2")}
                control={control}
                render={({ field }) => {
                  const selectedOption = procedureCode1List.find(
                    (option) => option.value == code1
                  );
                  const fallbackOption = { label: code1, value: code1 };
                  return (
                    <ReactSelect
                      {...field}
                      fullWidth
                      value={selectedOption || fallbackOption}
                      onChange={(e) => {
                        setcode1(e.value);
                        setcharges1(e.qasim);
                        setValue("cpt2", e.value);
                        setUNIT1(e.unit);
                      }}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          width: "99%",
                        }),
                      }}
                      options={procedureCode1List}
                    />
                  );
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={3}>
              <Typography
                style={{ fontSize: "16px", textDecoration: "underline" }}
              >
                Diagnosis code:
              </Typography>

              <Controller
                name="dx2"
                {...register("dx2")}
                control={control}
                render={({ field }) => {
                  const selectedOptions = d1.map((code) => {
                    const found = diagnosisList.find(
                      (option) => String(option.value) === String(code)
                    );
                    return found || { label: code, value: code }; // fallback if not found
                  });
                  return (
                    <ReactSelect
                      {...field}
                      fullWidth
                      isMulti={true}
                      value={selectedOptions}
                      onChange={(selectedOptions) => {
                        const selectedValues =
                          selectedOptions?.map((opt) => String(opt.value)) ||
                          []; // Ensure consistent type
                        setd1(selectedValues);
                      }}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          width: "99%",
                        }),
                      }}
                      options={diagnosisList}
                    />
                  );
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={3}>
              <Typography
                style={{ fontSize: "16px", textDecoration: "underline" }}
              >
                DOS
              </Typography>

              <Controller
                name="dos1"
                margin="dense"
                {...register("dos1")}
                control={control}
                render={({ field }) => (
                  <TextField
                    size="small"
                    {...field}
                    style={{ width: "99%" }}
                    type="date"
                    value={dos1 ? dos1 : ""}
                    onChange={(e) => {
                      setValue("dos1", e.target.value);
                      setdos1(e.target.value);
                    }}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={3}>
              <Typography
                style={{ fontSize: "16px", textDecoration: "underline" }}
              >
                Charge $
              </Typography>

              <Controller
                name="charges2"
                margin="dense"
                {...register("charges2")}
                control={control}
                render={({ field }) => (
                  <TextField
                    size="small"
                    {...field}
                    style={{ width: "99%" }}
                    value={charges1}
                    onChange={(e) => {
                      setValue("charges2", e.target.value);
                    }}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={3}>
              <Typography
                style={{ fontSize: "16px", textDecoration: "underline" }}
              >
                Procedure code:
              </Typography>
              <Controller
                name="cpt3"
                {...register("cpt3")}
                control={control}
                render={({ field }) => {
                  const selectedOption = procedureCode1List.find(
                    (option) => option.value == code2
                  );
                  const fallbackOption = { label: code2, value: code2 };
                  return (
                    <ReactSelect
                      {...field}
                      fullWidth
                      value={selectedOption || fallbackOption}
                      onChange={(e) => {
                        setcode2(e.value);
                        setcharges2(e.qasim);
                        setValue("cpt3", e.value);
                        setUNIT2(e.unit);
                      }}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          width: "99%",
                        }),
                      }}
                      options={procedureCode1List}
                    />
                  );
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={3}>
              <Typography
                style={{ fontSize: "16px", textDecoration: "underline" }}
              >
                Diagnosis code:
              </Typography>

              <Controller
                name="dx3"
                {...register("dx3")}
                control={control}
                render={({ field }) => {
                  const selectedOptions = d2.map((code) => {
                    const found = diagnosisList.find(
                      (option) => String(option.value) === String(code)
                    );
                    return found || { label: code, value: code }; // fallback if not found
                  });
                  return (
                    <ReactSelect
                      {...field}
                      fullWidth
                      isMulti={true}
                      value={selectedOptions}
                      onChange={(selectedOptions) => {
                        const selectedValues =
                          selectedOptions?.map((opt) => String(opt.value)) ||
                          []; // Ensure consistent type
                        setd2(selectedValues);
                      }}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          width: "99%",
                        }),
                      }}
                      options={diagnosisList}
                    />
                  );
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={3}>
              <Typography
                style={{ fontSize: "16px", textDecoration: "underline" }}
              >
                DOS
              </Typography>

              <Controller
                name="dos2"
                margin="dense"
                {...register("dos2")}
                control={control}
                render={({ field }) => (
                  <TextField
                    size="small"
                    {...field}
                    style={{ width: "99%" }}
                    type="date"
                    value={dos2}
                    onChange={(e) => {
                      setValue("dos2", e.target.value);
                      setdos2(e.target.value);
                    }}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={3}>
              <Typography
                style={{ fontSize: "16px", textDecoration: "underline" }}
              >
                Charge $
              </Typography>
              <Controller
                name="charges3"
                margin="dense"
                {...register("charges3")}
                control={control}
                render={({ field }) => (
                  <TextField
                    size="small"
                    {...field}
                    style={{ width: "99%" }}
                    value={charges2}
                    onChange={(e) => {
                      setValue("charges3", e.target.value);
                    }}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={3}>
              <Typography
                style={{ fontSize: "16px", textDecoration: "underline" }}
              >
                Procedure code:
              </Typography>
              <Controller
                name="cpt3"
                {...register("cpt3")}
                control={control}
                render={({ field }) => {
                  const selectedOption = procedureCode1List.find(
                    (option) => option.value == code3
                  );
                  const fallbackOption = { label: code3, value: code3 };
                  return (
                    <ReactSelect
                      {...field}
                      fullWidth
                      value={selectedOption || fallbackOption}
                      onChange={(e) => {
                        setcode3(e.value);
                        setcharges3(e.qasim);
                        setValue("cpt3", e.value);
                        setUNIT3(e.unit);
                      }}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          width: "99%",
                        }),
                      }}
                      options={procedureCode1List}
                    />
                  );
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={3}>
              <Typography
                style={{ fontSize: "16px", textDecoration: "underline" }}
              >
                Diagnosis code:
              </Typography>

              <Controller
                name="dx3"
                {...register("dx3")}
                control={control}
                render={({ field }) => {
                  const selectedOptions = d3.map((code) => {
                    const found = diagnosisList.find(
                      (option) => String(option.value) === String(code)
                    );
                    return found || { label: code, value: code }; // fallback if not found
                  });
                  return (
                    <ReactSelect
                      {...field}
                      fullWidth
                      isMulti={true}
                      value={selectedOptions}
                      onChange={(selectedOptions) => {
                        const selectedValues =
                          selectedOptions?.map((opt) => String(opt.value)) ||
                          []; // Ensure consistent type
                        setd3(selectedValues);
                      }}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          width: "99%",
                        }),
                      }}
                      options={diagnosisList}
                    />
                  );
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={3}>
              <Typography
                style={{ fontSize: "16px", textDecoration: "underline" }}
              >
                DOS
              </Typography>

              <Controller
                name="dos2"
                margin="dense"
                {...register("dos2")}
                control={control}
                render={({ field }) => (
                  <TextField
                    size="small"
                    {...field}
                    style={{ width: "99%" }}
                    type="date"
                    value={dos3}
                    onChange={(e) => {
                      setValue("dos2", e.target.value);
                      setdos3(e.target.value);
                    }}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={3}>
              <Typography
                style={{ fontSize: "16px", textDecoration: "underline" }}
              >
                Charge $
              </Typography>
              <Controller
                name="charges3"
                margin="dense"
                {...register("charges3")}
                control={control}
                render={({ field }) => (
                  <TextField
                    size="small"
                    {...field}
                    style={{ width: "99%" }}
                    value={charges3}
                    onChange={(e) => {
                      setValue("charges3", e.target.value);
                    }}
                  />
                )}
              />
            </Grid>

            {rights.Claims_FrontOffice_Notes && (
              <>
                <Grid item xs={12} style={{ marginTop: "10px" }}>
                  <Typography
                    sx={{
                      fontWeight: "bold",
                    }}
                  >
                    Front Office Notes:
                  </Typography>
                  <Controller
                    name="frontnote"
                    {...register("frontnote")}
                    control={control}
                    render={({ field }) => (
                      <TextareaAutosize
                        aria-label="minimum height"
                        minRows={3}
                        placeholder="Enter comments"
                        style={{
                          width: "100%",
                          borderRadius: "8px",
                          border: "2px solid #black",
                          height: "60px", // set a fixed height here
                        }}
                        {...field}
                        fullWidth
                      />
                    )}
                  />
                </Grid>
              </>
            )}
            {rights.Claims_BackOffice_Notes && (
              <>
                <Grid item xs={12} style={{ marginTop: "10px" }}>
                  <Typography
                    sx={{
                      fontWeight: "bold",
                    }}
                  >
                    Back Office Notes:
                  </Typography>
                  <Controller
                    name="backnote"
                    {...register("backnote")}
                    control={control}
                    render={({ field }) => (
                      <TextareaAutosize
                        aria-label="minimum height"
                        minRows={3}
                        placeholder="Enter comments"
                        style={{
                          width: "100%",
                          borderRadius: "8px",
                          border: "2px solid #black",
                          height: "60px", // set a fixed height here
                        }}
                        {...field}
                        onChange={(e) => {
                          field.onChange(e);
                          setValue("followUpTime", "14");
                        }}
                        fullWidth
                      />
                    )}
                  />
                </Grid>
              </>
            )}
            <Grid item xs={12}>
              <Typography
                sx={{
                  fontWeight: "bold",
                }}
              >
                Additional Information:
              </Typography>
              <Controller
                name="additionalInformation"
                {...register("additionalInformation")}
                control={control}
                render={({ field }) => (
                  <TextareaAutosize
                    aria-label="minimum height"
                    minRows={3}
                    placeholder="Enter Additional Information"
                    style={{
                      width: "100%",
                      borderRadius: "8px",
                      border: "2px solid #black",
                      height: "60px", // set a fixed height here
                    }}
                    {...field}
                    onChange={(e) => {
                      field.onChange(e);
                    }}
                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid item md={6} xs={12} sm={12} style={{ marginTop: "10px" }}>
              <Grid item md={12} xs={12} sm={12} style={{ marginTop: "10px" }}>
                <Box display="flex" alignItems="center" gap={1}>
                  <input
                    name="acceptAssignment"
                    size="small"
                    type="checkbox"
                    {...register("acceptAssignment")}
                    onChange={(e) => {
                      const checked = e.target.checked;
                      setValue("acceptAssignment", checked ? true : "");
                      setValue("dontAcceptAssignment", "");
                      setAssignmentError("");
                    }}
                    id="acceptAssignment"
                    style={{ width: "18px", height: "18px" }}
                  />

                  <Typography
                    component="label"
                    htmlFor="acceptAssignment"
                    style={{ fontSize: "16px", cursor: "pointer" }}
                  >
                    <b>Accept Assignment</b> (payment will go directly to your
                    office)
                  </Typography>
                </Box>
              </Grid>
              <Grid item md={12} xs={12} sm={12} style={{ marginTop: "10px" }}>
                <Box display="flex" alignItems="center" gap={1}>
                  <input
                    name="dontAcceptAssignment"
                    size="small"
                    type="checkbox"
                    {...register("dontAcceptAssignment")}
                    id="dontAcceptAssignment"
                    onChange={(e) => {
                      const checked = e.target.checked;
                      setValue("dontAcceptAssignment", checked ? true : "");
                      setValue("acceptAssignment", "");
                      setAssignmentError("");
                    }}
                    style={{ width: "18px", height: "18px" }}
                  />
                  <Typography
                    component="label"
                    htmlFor="dontAcceptAssignment"
                    style={{ fontSize: "16px", cursor: "pointer" }}
                  >
                    <b>Do NOT Accept Assignment</b> (payment issued to the
                    patient)
                  </Typography>
                </Box>
                {assignmentError && (
                   <Typography color="error" style={{ fontSize: "14px" }}>
                    {assignmentError}
                  </Typography>
                )}
              </Grid>
              {claimId > 0 && (
                <>
                  <Grid
                    item
                    md={12}
                    xs={12}
                    sm={12}
                    style={{ marginTop: "10px" }}
                  >
                    <Box display="flex" alignItems="center" gap={3}>
                      {/* Radio: Save as Pending */}
                      <Box display="flex" alignItems="center" gap={1}>
                        <input
                          type="radio"
                          id="savePending"
                          value="Pending"
                          {...register("statusType")}
                          style={{ width: "18px", height: "18px" }}
                        />
                        <Typography
                          component="label"
                          htmlFor="savePending"
                          style={{ fontSize: "16px", cursor: "pointer" }}
                        >
                          <b>Save as Pending</b>
                        </Typography>
                      </Box>

                      {/* Radio: Save as Secondary Pending */}
                      <Box display="flex" alignItems="center" gap={1}>
                        <input
                          type="radio"
                          id="saveSecondaryPending"
                          value="Secondary Pending"
                          {...register("statusType")}
                          style={{ width: "18px", height: "18px" }}
                        />
                        <Typography
                          component="label"
                          htmlFor="saveSecondaryPending"
                          style={{ fontSize: "16px", cursor: "pointer" }}
                        >
                          <b>Save as Secondary Pending</b>
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>
                </>
              )}
            </Grid>
            {User_Type === "Front Office" ||
            User_Type === "Front Office Admin" ? (
              <Grid
                item
                md={6}
                xs={12}
                sm={12}
                style={{ marginTop: "10px" }}
              ></Grid>
            ) : (
              <Grid item md={6} xs={12} sm={12} style={{ marginTop: "10px" }}>
                <Grid
                  item
                  md={12}
                  xs={12}
                  sm={12}
                  style={{ marginTop: "10px" }}
                >
                  <Box display="flex" alignItems="center" gap={1}>
                    <input
                      type="radio"
                      value="14" // 2 weeks = 14 days
                      {...register("followUpTime")}
                      id="defaultTwoweek"
                      style={{ width: "18px", height: "18px" }}
                    />
                    <Typography
                      component="label"
                      htmlFor="defaultTwoweek"
                      style={{ fontSize: "16px", cursor: "pointer" }}
                    >
                      Default Follow Up Time (2 Weeks)
                    </Typography>
                  </Box>
                </Grid>
                <Grid
                  item
                  md={12}
                  xs={12}
                  sm={12}
                  style={{ marginTop: "10px" }}
                >
                  <Box display="flex" alignItems="center" gap={1}>
                    <input
                      type="radio"
                      value="5"
                      {...register("followUpTime")}
                      id="FollowUp5Days"
                      style={{ width: "18px", height: "18px" }}
                    />
                    <Typography
                      component="label"
                      htmlFor="FollowUp5Days"
                      style={{ fontSize: "16px", cursor: "pointer" }}
                    >
                      Follow Up 5 Days
                    </Typography>
                  </Box>
                </Grid>
                <Grid
                  item
                  md={12}
                  xs={12}
                  sm={12}
                  style={{ marginTop: "10px" }}
                >
                  <Box display="flex" alignItems="center" gap={1}>
                    <input
                      type="radio"
                      value="10"
                      {...register("followUpTime")}
                      id="FollowUp10Days"
                      style={{ width: "18px", height: "18px" }}
                    />
                    <Typography
                      component="label"
                      htmlFor="FollowUp10Days"
                      style={{ fontSize: "16px", cursor: "pointer" }}
                    >
                      Follow Up 10 Days
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            )}
            <Grid container spacing={2} m={2}>
              {claimId !== 0 && rights.Claim_Send_Mail &&  (
                <Grid item xs={4}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={showDropdown}
                        onClick={(e) => setShowDropdown(!showDropdown)}
                        color="primary"
                      />
                    }
                    label="Email Notice of Claim Complete"
                  />
                </Grid>
              )}
              {/* Dropdown */}
              {showDropdown && (
                <Grid item xs={4}>
                  <ReactSelect
                    fullWidth
                    value={userList?.find(
                      (option) => option.value == selectedUser
                    )}
                    onChange={(option) => setSelectedUser(option.value)}
                    placeholder="Search or Select User"
                    options={userList}
                    styles={{
                      menu: (provided) => ({
                        ...provided,
                        maxHeight: "300px", // max height of dropdown
                        overflowY: "auto", // enable scroll if options exceed
                      }),
                      menuList: (provided) => ({
                        ...provided,
                        maxHeight: "300px",
                      }),
                    }}
                  />
                </Grid>
              )}

              {/* Send Button */}
              {/* {showDropdown && (
        <Grid item xs={3} >
          <Button
            variant="contained"
            color="primary"
            onClick={handleSendEmail}
            disabled={!selectedUser}
          >
          Send Email
          </Button>
        </Grid>
      )} */}
            </Grid>
            {submittedprop == true ? (
              <>
                <Grid item xs={10} mb={4}>
                  <Typography style={{ fontWeight: "bold", color: "red" }}>
                    {" "}
                    This Record already Submitted
                  </Typography>
                </Grid>
              </>
            ) : (
              <></>
            )}

            <Grid container spacing={2}>
              <Grid
                item
                xs={12}
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  margin: "15px", // top, left, right margin
                  marginBottom: "100px", // niche footer ke sath chipkane ke liye
                }}
              >
                {/* {claimId !== 0 && (
                  <Grid item xs={2} style={{ marginRight: "8px" }}>
                    <Button
                      className="Button"
                      variant="gradient"
                      onClick={handleOpenPreview}
                      fullWidth
                      style={{
                        height: "40px",
                        color: "white",
                        fontSize: "14px",
                        display: "flex",
                        textTransform: "none",
                        gap: "8px",
                      }}
                    >
                      Preview
                    </Button>
                  </Grid>
                )} */}
                {rights.Download_Claims && claimId !== 0 ? (
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={2}
                    style={{ marginRight: "8px" }}
                  >
                    <Button
                      className="Button"
                      onClick={onSubmitprint}
                      variant="gradient"
                      disabled={submitting}
                      fullWidth
                      style={{
                        height: "40px",
                        color: "white",
                        fontSize: "14px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        textTransform: "none",
                        gap: "8px",
                      }}
                    >
                      {DownLoadSubmiting ? (
                        "Downloading..."
                      ) : (
                        <>
                          <Download
                            fontSize="medium"
                            style={{
                              color: "white",
                              paddingBottom: "2px",
                            }}
                          />
                          Download
                        </>
                      )}
                    </Button>
                  </Grid>
                ) : null}

                {claimId === 0 && (
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={3}
                    style={{ marginLeft: "8px" }}
                  >
                    <Button
                      onClick={handleSubmit(onSubmittoluxbilling)}
                      variant="gradient"
                      disabled={submitting}
                      fullWidth
                      style={{
                        height: "40px",
                        color: "white",
                        fontSize: "13px",
                        backgroundColor: "#377562",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        textTransform: "none",
                        gap: "5px",
                      }}
                    >
                      <SaveOutlinedIcon
                        fontSize="medium"
                        style={{
                          color: "white",
                          paddingRight: "5px",
                        }}
                      />
                      Submit Claim to Luxbilling
                    </Button>
                  </Grid>
                )}

                {claimId !== 0 && rights?.keep_Claim_pending && (
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={3}
                    style={{ marginLeft: "8px" }}
                  >
                    <Button
                      onClick={handleSubmit(onSubmitPending)}
                      variant="gradient"
                      fullWidth
                      disabled={submitting}
                      style={{
                        height: "40px",
                        backgroundColor: "#FFA500",
                        color: "white",
                        fontSize: "12px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        textTransform: "none",
                        gap: "5px",
                      }}
                    >
                      <SaveOutlinedIcon
                        fontSize="medium"
                        style={{
                          color: "white",
                          paddingBottom: "2px",
                        }}
                      />
                      {/* Save and keep Claim Pending */}
                      Save
                    </Button>
                  </Grid>
                )}

                {claimId !== 0 && rights?.Claims_Save_And_Complete && (
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    style={{ marginLeft: "8px" }}
                  >
                    <Button
                      onClick={handleSubmit(onSubmit)}
                      variant="gradient"
                      fullWidth
                      disabled={submitting}
                      style={{
                        height: "40px",
                        backgroundColor: "#377562",
                        color: "white",
                        fontSize: "12px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        textTransform: "none",
                        gap: "5px",
                      }}
                    >
                      <SaveOutlinedIcon
                        fontSize="medium"
                        style={{
                          color: "white",
                          paddingBottom: "2px",
                        }}
                      />
                      Save and Mark Claim Completed By LuxBilling
                    </Button>
                  </Grid>
                )}
                {claimId !== 0 && rights?.Send_To_Payer_Claims && (
                  <Grid
                    item
                    md={12}
                    sm={12}
                    xs={12}
                    style={{
                      padding: "8px",
                      display: "flex",
                      justifyContent: "flex-end", // Aligns items to the right
                      alignItems: "center",
                    }}
                  >
                    <Button
                      className="Button"
                      variant="gradient"
                      onClick={handleSubmit(onSubmitEdi)}
                      style={{
                        margin: "10px",
                        width: "240px",
                        height: "40px",
                        color: "white",
                        fontSize: "14px",
                      }}
                    >
                      Send to Payer
                    </Button>
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ClaimRegistration;
